// extracted by mini-css-extract-plugin
export default {"popoverContent":"UserSearchBar_popoverContent__Xes+7","popoverContentInner":"UserSearchBar_popoverContentInner__mGidH","popoverSection":"UserSearchBar_popoverSection__4eNV-"};